
import { Box } from "@mui/material";
import KanbanBoard from "../Table/KanbanBoard"
import { useState } from "react";
import FiltroDeData from '../Dashboard/FiltroDeData';

const Kanban = ({
    dateFilter,
    setDateFilter,
    tempDateFilter,        // Nova
    setTempDateFilter,     // Nova
    tempStartDate,         // Nova
    setTempStartDate,      // Nova
    tempEndDate,           // Nova
    setTempEndDate,        // Nova
    handleApplyFilters,    // Nova
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    setForceTokenExpired,
    handleWhatsAppIdClick
}) => {

    const [, setTotalLeads] = useState();

    return (
        <>
            {/* Adicione o FiltroDeData aqui, ANTES do Box existente */}
            <FiltroDeData
                startDate={tempStartDate}
                setStartDate={setTempStartDate}
                endDate={tempEndDate}
                setEndDate={setTempEndDate}
                setDateFilter={setTempDateFilter}
                dateFilter={tempDateFilter}
                handleApplyFilters={handleApplyFilters}
            />

            <Box
                sx={{
                    maxWidth: '100%',
                    m: 'auto',
                }}
            >
                <KanbanBoard
                    dateFilter={dateFilter}
                    startDate={startDate}
                    endDate={endDate}
                    setForceTokenExpired={setForceTokenExpired}
                    handleWhatsAppIdClick={handleWhatsAppIdClick}
                    setTotalLeads={setTotalLeads}
                />
            </Box>
        </>
    );
};

export default Kanban;

